import React, { useEffect } from "react";
import { withRouter } from "next/router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchUserDetails } from "actions/auth";
import MarketingToolsQRCode from "components/Marketing/Tools/QRCode";
import Layout from "components/Layout";
import { authAndRedirect } from "utils/route";

const ToolsQrCode = (props) => {
  useEffect(() => {
    authAndRedirect(props);
  }, []);

  return <Layout>{() => <MarketingToolsQRCode {...props} />}</Layout>;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchUserDetails
    },
    dispatch
  )
});

export default withRouter(connect(null, mapDispatchToProps)(ToolsQrCode));
